import React from "react";

export default function SQLServer_QUOTENAME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_QUOTENAME</h1>
      <p>This is the SQLServer_QUOTENAME component generated from the SQL JSON.</p>
    </div>
  );
}
